import { dashboardDomain } from "@dashboard-config"

const DASHBOARD_HOST_SUFFIX = ".dashboard.playbrain.com"

const DASHBOARD_APP_PREFIXES = ["/dashboard", "/login", "/auth", "/api"]
const DASHBOARD_BROWSER_PREFIXES = ["/dashboard", "/login", "/auth"]
const PUBLIC_PLAYBRAIN_HOSTNAMES = new Set([
  "playbrain.com",
  "www.playbrain.com",
  "dev.playbrain.com",
  "staging.playbrain.com",
])

export function isDashboardHostname(hostname: string) {
  const normalizedHostname = hostname.split(":")[0]?.toLowerCase() ?? ""
  return (
    normalizedHostname === "dashboard.playbrain.com" || normalizedHostname.endsWith(DASHBOARD_HOST_SUFFIX)
  )
}

export function shouldRouteDashboardHostToCms(hostname: string, pathname: string) {
  if (!isDashboardHostname(hostname)) return false
  const normalizedPathname = pathname.split(/[?#]/)[0] || "/"
  return !DASHBOARD_APP_PREFIXES.some(
    (prefix) => normalizedPathname === prefix || normalizedPathname.startsWith(`${prefix}/`)
  )
}

export function isPublicPlaybrainHostname(hostname: string) {
  return PUBLIC_PLAYBRAIN_HOSTNAMES.has(normalizedHostname(hostname))
}

export function dashboardAppHostRedirectUrl(hostname: string, href: string, stage?: string) {
  if (isDashboardHostname(hostname) || !isPublicPlaybrainHostname(hostname)) return null

  const parsed = new URL(href, "https://playbrain.com")
  const normalizedPathname = parsed.pathname || "/"
  const isDashboardAppPath = DASHBOARD_BROWSER_PREFIXES.some(
    (prefix) => normalizedPathname === prefix || normalizedPathname.startsWith(`${prefix}/`)
  )
  if (!isDashboardAppPath) return null

  const targetDomain = dashboardDomain(stage)
  if (targetDomain.startsWith("localhost")) return null
  return `https://${targetDomain}${normalizedPathname}${parsed.search}${parsed.hash}`
}

function normalizedHostname(hostname: string) {
  return hostname.split(":")[0]?.toLowerCase() ?? ""
}
